"use client";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    offers: {}
}

export const offerResponseSlice = createSlice({
    name: 'offerResponse',
    initialState,
    reducers: {
        addOffer: (state, action)=> {
            // console.log ("from redux action: " + JSON.stringify(action.payload));
            state.offers = action.payload;
        }
    }
});

export const {addOffer} = offerResponseSlice.actions;

export default offerResponseSlice.reducer;